const studentPayResult = {
  path: 'studentApplyResult',
  component: resolve => require(['../../../../components/pages/signUp/studentApplyResult'], resolve)
}
export default studentPayResult



// WEBPACK FOOTER //
// ./src/router/pages/signUp/studentApplyResult/index.js